import { Company, OrderItem, Product, ProductionSector, Table } from '../types';

export type ProductionTicket = {
  tableId: number;
  tableLabel: string;
  items: OrderItem[];
};

const beverageKeywords = ['cerveja', 'chopp', 'drink', 'bebida', 'refrigerante', 'suco', 'água', 'agua', 'vinho', 'whisky', 'vodka', 'gin', 'brahma', 'heineken', 'spaten'];
const escapeHtml = (value: string) => value.replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character] || character));

export const itemBelongsToSector = (item: OrderItem, products: Product[], sector: ProductionSector) => {
  const product = products.find(productItem => productItem.id === item.productId);
  const area = item.productionArea || product?.productionArea || 'AUTO';
  if (area === 'BOTH') return true;
  if (area === sector) return true;
  if (area !== 'AUTO') return false;
  const label = `${product?.category || ''} ${item.productName}`.toLowerCase();
  return sector === 'BAR' ? beverageKeywords.some(keyword => label.includes(keyword)) : !beverageKeywords.some(keyword => label.includes(keyword));
};

export const getProductionTickets = (tables: Table[], products: Product[], sector: ProductionSector, reprint: boolean): ProductionTicket[] => tables
  .filter(table => table.status !== 'FREE')
  .map(table => ({
    tableId: table.id,
    tableLabel: table.name || table.label,
    items: table.items.filter(item => item.status !== 'DELIVERED'
      && itemBelongsToSector(item, products, sector)
      && (reprint || !item.productionPrints?.[sector])),
  }))
  .filter(ticket => ticket.items.length > 0);

const ticketHtml = (ticket: ProductionTicket, sector: ProductionSector, companyName: string, reprint: boolean, printedAt: Date) => {
  const attendants = [...new Set(ticket.items.map(item => item.waiterName).filter(Boolean))].join(', ') || 'PDV';
  const rows = ticket.items.map(item => `<li><strong>${item.quantity}x ${escapeHtml(item.productName)}</strong>${item.notes ? `<br><em>OBS.: ${escapeHtml(item.notes)}</em>` : ''}</li>`).join('');
  return `<section class="ticket"><header><strong>${escapeHtml(companyName)}</strong><h1>${sector === 'KITCHEN' ? 'COZINHA' : 'BAR'}</h1>${reprint ? '<b class="reprint">REIMPRESSÃO</b>' : '<b>NOVOS ITENS</b>'}</header><p><b>${escapeHtml(ticket.tableLabel)}</b><br>Horário: ${printedAt.toLocaleString('pt-BR')}<br>Atendente: ${escapeHtml(attendants)}</p><ul>${rows}</ul><footer>${reprint ? 'Reimpressão identificada no FlowTab' : 'Comanda de produção'}</footer></section>`;
};

export const openProductionPrint = (company: Company, tickets: ProductionTicket[], sector: ProductionSector, reprint: boolean) => {
  const printWindow = window.open('', '_blank', 'noopener,noreferrer,width=420,height=680');
  if (!printWindow) return false;
  const printedAt = new Date();
  printWindow.document.write(`<!doctype html><html><head><title>Comandas ${sector === 'KITCHEN' ? 'Cozinha' : 'Bar'}</title><style>@page{size:80mm auto;margin:3mm}*{box-sizing:border-box}body{font-family:monospace;margin:0;color:#000}.ticket{width:74mm;padding:2mm 0;border-bottom:1px dashed #000;page-break-after:always}.ticket:last-child{page-break-after:auto}header{text-align:center}h1{font-size:16px;margin:4px 0}.reprint{display:block;border:2px solid #000;padding:3px;margin:4px 0}p{font-size:12px;line-height:1.45}ul{list-style:none;padding:0;margin:10px 0}li{padding:8px 0;border-top:1px dashed #555;font-size:13px;line-height:1.35}em{font-style:normal;font-weight:bold}footer{font-size:10px;text-align:center;margin-top:12px}</style></head><body>${tickets.map(ticket => ticketHtml(ticket, sector, company.name, reprint, printedAt)).join('')}</body></html>`);
  printWindow.document.close();
  printWindow.focus();
  window.setTimeout(() => printWindow.print(), 200);
  return true;
};
